import { blackColors } from 'assets/jss/material-dashboard-pro-react';

const walletStyle = (theme) => ({
	noCardsAddedWrapper: {
		textAlign: 'center',
		marginTop: 200,
		[theme.breakpoints.down('sm')]: {
			marginTop: 100,
		},
	},
	cardImageWrapper: {
		marginTop: 16,
	},
	singleCardWrapper: {
		position: 'relative',
		marginBottom: 24,
		'&:hover': {
			'& > div:first-of-type': {
				opacity: 0.24,
			},
			'& > div:last-of-type': {
				opacity: 1,
			},
		},
	},
	cardContentWrapper: {
		cursor: 'pointer',
		transition: 'all .3s ease-in-out',
	},
	backgroundIcon: {
		boxShadow: `0 8px 8px -6px ${blackColors[3]}`,
		borderRadius: 4,
		[theme.breakpoints.down('sm')]: {
			maxWidth: '100%',
		},
	},
	cardsListWrapper: {
		marginTop: 60,
	},
	cardNumber: {
		position: 'absolute',
		top: '50%',
		left: 215,
		[theme.breakpoints.only('sm')]: {
			left: '70%',
			top: '48%',
		},
	},
	deleteCardButtonWrapper: {
		position: 'absolute',
		top: '38%',
		left: 101,
		transition: 'all .3s ease-in-out',
		opacity: 0,
		[theme.breakpoints.only('sm')]: {
			left: '50%',
			transform: 'translate(-50%, -50%)',
			top: '50%',
		},
	},
	successDialogBody: {
		marginBottom: 18,
	},
});

export default walletStyle;
